<under-ui-search-bar
  class="search"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  [control]="search"
  [placeholder]="'FIELD.PLACEHOLDER.SEARCH' | translate"
  [subscriptSizing]="'dynamic'"
  (click)="onOpenOverlay()">
</under-ui-search-bar>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="transparent-background"
  [cdkConnectedOverlayOffsetY]="15"
  [cdkConnectedOverlayPositions]="position"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="(showPanel$ | async) === true"
  (backdropClick)="onBackdropClick()">

  <section class="uni-flex uni-flex-column gap-0.5 global-search-panel mat-elevation-z4">
    @if (loading$ | async) {
      @for (item of skeletonSize; track item) {
        <under-ui-skeleton height="55px"></under-ui-skeleton>
      }
    } @else {
      @switch (globalResult.status) {
        @case (globalStatusSearch.SUCCESS) {
          @if (globalResult.response.items.length) {
            @for (item of globalResult.response.items; track item.entityId) {
              <under-ui-result-global-search-by-entity
                [item]="item">
              </under-ui-result-global-search-by-entity>
            }
          } @else {
            <ng-container
              *ngTemplateOutlet="messageContent; context: { text: 'GLOBAL_SEARCH.EMPTY_DATA' }">
            </ng-container>
          }
        }
        @case (globalStatusSearch.PADDING) {
          <ng-container
            *ngTemplateOutlet="messageContent; context: { text: 'GLOBAL_SEARCH.USE_SEARCH' }">
          </ng-container>
        }
        @case (globalStatusSearch.ERROR) {
          <ng-container
            *ngTemplateOutlet="messageContent; context: { text: 'GLOBAL_SEARCH.ERROR_RESPONSE' }">
          </ng-container>
        }
      }
    }
  </section>
</ng-template>

<ng-template #messageContent let-text="text">
  <div class="uni-flex uni-justify-center">{{ text | translate }}</div>
</ng-template>
